/**
 * @module パスコード_生体認証ダイアログコンポーネント
 */
var mixin = {
  data() {
    return {
      type0: 0,
      type1: 1,
      type2: 2,
      type3: 3,
      type4: 4,
    };
  },
  created() {
    // this.$mount();
    // document.body.appendChild(this.$el);
    this.show = true;
  },
  methods: {
    close() {
      this.show = false;
      // setTimeout(() => {
      //   if (document.body.contains(this.$el))
      //     document.body.removeChild(this.$el);
      //   this.$destroy();
      // }, 200);
    },
  },
};

export default {
  mixins: [mixin],
  name: 'PasscodeBioAuthDialog',
  props: {
    value: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    labelList: {
      type: Array,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
    cancelName: {
      type: String,
      required: true,
    },
    okBtnName: {
      type: String,
      required: true,
    },
    cancelAction: {
      type: Function,
      required: true,
    },
    okAction: {
      type: Function,
      required: true,
    },
    cancelButtonType: {
      type: Number,
      required: false,
      default: 0,
    },
    okButtonType: {
      type: Number,
      required: false,
      default: 1,
    },
    // キャンセルボタンを非表示/表示
    cancelButtonIsVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
    // キャンセルボタンを非活性/活性
    cancelButtonIsActive: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      show: false,
      test: '',
      okLoadFlag: false,
      cancelLoadFlag: false,
      lists: this.labelList,
      numberKey: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0'],
      deleteKey: '×',
    };
  },
  /** @type {Methods} */
  methods: {
    /**
     * パスコードのスタイル取得
     * @param {number} idx パスコードの位置
     * @returns string スタイル文字列
     */
    circleStyle(idx) {
      return this.value.length >= idx ? 'circle' : 'circle-outline';
    },
    /**
     * OKボタン押下時の処理
     */
    ok() {
      this.okLoadFlag = true;
      this.okAction();
      this.close();
      this.okLoadFlag = false;
    },
    /**
     * キャンセルボタン押下時の処理
     */
    cancel() {
      this.cancelLoadFlag = true;
      this.cancelAction();
      // this.close(); // 生体認証ボタンはクリックした後閉じない。
      this.cancelLoadFlag = false;
    },
    /**
     * パスコード入力・削除処理
     * @param {*} inputValue 入力値または削除キー
     * @param {*} event イベント
     */
    clickNumericKeypad(inputValue, event) {
      const btnAnimation = event.target.closest('.btn-animation');
      btnAnimation.classList.add('--active');
      setTimeout(() => {
        btnAnimation.classList.remove('--active');
      }, 150);
      if (inputValue === this.deleteKey) {
        // 一文字削除
        this.$emit('input', this.value.slice(0, -1));
        return;
      }

      if (this.value.length < 4) {
        this.$emit('input', this.value + inputValue);
      }
    },
  },
};
